import { useState } from "react";

const FAQS = [
  {
    q: "公開日が近くても相談できますか？",
    a: "公開希望日と制作内容を確認のうえ、対応できる範囲をご案内します。まずはお日にちと概要をお聞かせください。",
  },
  {
    q: "文章や写真がそろっていなくても大丈夫ですか？",
    a: "現在ある資料をもとに、必要な情報と素材を一緒に整理していきます。事前にすべてを用意いただく必要はありません。",
  },
  {
    q: "期間が決まっていない事業でも相談できますか？",
    a: "新規事業など、利用期間がまだ決まっていないサイトもご相談いただけます。公開後の運用方法も含めてご案内します。",
  },
  {
    q: "公開後の更新やフォーム追加も相談できますか？",
    a: "更新の内容や頻度を確認し、対応範囲と費用をご案内します。必要に応じて制作後のサポートもご相談ください。",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-cream py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600">FAQ</p>
        <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-navy-950 md:text-4xl">
          よくある質問
        </h2>

        <div className="mt-10 flex flex-col divide-y divide-navy-100 border-y border-navy-100">
          {FAQS.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={faq.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 py-5 text-left"
                >
                  <span className="font-heading text-base font-bold text-navy-950 md:text-lg">
                    {faq.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-lime-400 text-navy-950" : "bg-navy-100 text-navy-700"
                    }`}
                  >
                    <i
                      className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg`}
                      aria-hidden="true"
                    />
                  </span>
                </button>
                {isOpen && (
                  <p className="pb-6 pr-12 text-sm leading-relaxed text-navy-600">{faq.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}